import { InjectionToken, inject } from '@angular/core';

import { isNewStudyPageEnabled } from '../../utils/new-study-page';
import { NgxsStudyReadSource } from './ngxs-study-read-source';
import { StoreStudyReadSource } from './store-study-read-source';
import { StudyReadSource } from './study-read-source';

/** The backing the facades read studies from, chosen once per session from the new-study-page flag. */
export const STUDY_READ_SOURCE = new InjectionToken<StudyReadSource>('STUDY_READ_SOURCE', {
  providedIn: 'root',
  factory: () => (isNewStudyPageEnabled() ? inject(StoreStudyReadSource) : inject(NgxsStudyReadSource)),
});
